import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FieldInput } from '../../../../common/components';
import { postLoginUser } from './actions/postLoginUser';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    // For testing only
    this.state = {
      username: '',
      password: ''
    };

    this.handleSubmitLogin = this.handleSubmitLogin.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleSubmitLogin(target) {
    target.preventDefault();
    const data = {
      username: this.state.username,
      password: this.state.password
    };
    this.props.loginUser(data);
  }

  renderMessage() {
    if (this.props.message) {
      return <p className='help is-danger'>
        {this.props.message}
      </p>;
    } else {
      return null;
    }
  }

  render() {
    return <div className='column is-primary'>
      <h3>Access your account</h3>
      <form action='/login' method='post' onSubmit={this.handleSubmitLogin}>
        <FieldInput
          label='Email address'
          type='email'
          name='username'
          value={this.state.username}
          placeholder='e.g. user@mail.com'
          required={true}
          onChange={this.handleChange} />
        <FieldInput
          label='Password'
          type='password'
          name='password'
          value={this.state.password}
          placeholder=''
          required={true}
          onChange={this.handleChange} />
        {this.renderMessage()}
        <div className='field'>
          <div className='control'>
            <button className='button is-info is-full-width'>Login</button>
          </div>
        </div>
        <a className="is-full-width is-centered is-white" href="/forgotPassword">Forgot password?</a>
      </form>
    </div>;
  }
}

LoginForm.propTypes = {
  message: PropTypes.string,
  loginUser: PropTypes.func
};

const mapDispathToProps = (dispatch) => {
  return {
    loginUser: (data) => { dispatch(postLoginUser(data)); }
  };
};

export default connect(null, mapDispathToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/LoginForm.jsx